import React, { useState } from 'react';
import { FieldRenderProps } from 'react-final-form';
import Select, { components, DropdownIndicatorProps } from 'react-select';
import Arrow from '../../../static/svg/arrow-down-orange.svg';
import * as styles from './selectMenu.module.scss';

export const SelectMenu = ({
  label,
  meta,
  value,
  options,
  rest,
  input,
  placeholder,
}: FieldRenderProps<string, HTMLElement>) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onMenuOpen = () => setIsMenuOpen(true);
  const onMenuClose = () => setIsMenuOpen(false);

  const DropdownIndicator = (props: DropdownIndicatorProps<true>) => {
    return (
      <components.DropdownIndicator {...props}>
        <Arrow
          className={
            isMenuOpen
              ? styles.iconDown
              : (meta.error || meta.submitError) && meta.touched
              ? styles.iconWarning
              : styles.iconUp
          }
        />
      </components.DropdownIndicator>
    );
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#f18841;' : 'white',
      borderRadius: '1rem',
      fontSize: '1.5rem',
      lineHeight: '1.4rem',
      color: state.isFocused ? 'white' : '#100c08',
    }),
    container: () => ({
      display: 'flex',
      flexDirection: 'column',
      gap: '0.625rem',
    }),
    control: (provided, state) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: '1rem',
      borderColor:
        (meta.error || meta.submitError) && meta.touched
          ? '1px solid #E73532'
          : '1px solid #100c08',
      padding: '0rem 1.4rem',
      color: (meta.error || meta.submitError) && meta.touched ? '#E73532' : 'black',
      backgroundColor: isMenuOpen ? 'white' : 'transparent',
    }),

    menu: () => ({
      borderRadius: '1rem',
      backgroundColor: ' transparent',
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      left: '0',
      top: '5rem',
    }),
    menuList: () => ({
      border: '1px solid white',
      borderRadius: '1rem',
      backgroundColor: 'white',
      // minHeight: '2.5rem',
    }),
    singleValue: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'white' : 'transparent',
      // minHeight: '2.5rem',
      fontSize: '1.5rem',
      lineHeight: '1.4rem',
      paddingTop: '1.2rem',
      paddingBottom: '0.8rem',
      paddingInline: '0',
    }),
    valueContainer: () => ({
      minHeight: '2.5rem',
      fontSize: '1.5rem',
      lineHeight: '1.4rem',
      display: 'flex',
      padding: '0',
      flex: 'unset',
    }),
    placeholder: () => ({
      paddingTop: '1.2rem',
      paddingBottom: '0.8rem',
      paddingInline: '0',
      minHeight: '2.5rem',
      fontSize: '1.5rem',
      lineHeight: '1.4rem',
    }),
  };

  return (
    <div className={styles.wrapper}>
      <label>{label}</label>
      <Select
        {...input}
        {...rest}
        components={{ DropdownIndicator, IndicatorSeparator: () => null }}
        options={options}
        isSearchable={false}
        placeholder={placeholder}
        styles={customStyles}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        value={input.value}
        onChange={input.onChange}
      />

      <p className={styles.warning}>
        {(meta.error || meta.submitError) && meta.touched && meta.error}
      </p>
    </div>
  );
};
